module.exports = "/images/star-icon.svg?79c326baa36bc69a0384201bbdb7763f";